module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayheavysnow@2-c6be27e767e50ce9698e7f472ebd6ed0.png";